import { render, staticRenderFns } from "./ViewData.vue?vue&type=template&id=a3324560&scoped=true"
import script from "./ViewData.vue?vue&type=script&lang=js"
export * from "./ViewData.vue?vue&type=script&lang=js"
import style0 from "./ViewData.vue?vue&type=style&index=0&id=a3324560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3324560",
  null
  
)

export default component.exports